var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9049 15.8401C39.9293 16.1928 39.9293 16.5454 39.9293 16.9013C39.9293 27.7451 31.6742 40.2513 16.5793 40.2513V40.2448C12.1203 40.2513 7.75381 38.974 4 36.5657C4.64839 36.6437 5.30002 36.6827 5.95328 36.6843C9.64859 36.6876 13.2383 35.4477 16.1454 33.1645C12.6338 33.0979 9.55434 30.8083 8.47857 27.4656C9.70871 27.7028 10.9762 27.6541 12.1836 27.3242C8.35507 26.5507 5.60065 23.1869 5.60065 19.2803C5.60065 19.2446 5.60065 19.2104 5.60065 19.1763C6.74142 19.8117 8.01869 20.1643 9.32521 20.2033C5.71928 17.7934 4.60776 12.9964 6.78529 9.24579C10.9519 14.3727 17.0993 17.4895 23.6986 17.8194C23.0372 14.9691 23.9407 11.9823 26.0727 9.97868C29.378 6.87163 34.5765 7.03088 37.6835 10.3346C39.5214 9.97218 41.283 9.29779 42.895 8.34228C42.2823 10.2419 41.0002 11.8556 39.2874 12.881C40.9141 12.6892 42.5034 12.2537 44 11.5891C42.8982 13.2401 41.5105 14.6783 39.9049 15.8401Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.eca276bd7d2b116be5f66c498e211b06.svg";
export { ForwardRef as ReactComponent };